import * as React from "react";
import Navbar from "../component/Navbar/Navbar";
import Carousels from "../component/Carousel/Carousels";
import Footer from "../component/Footer/Footer";
import About from "../component/Home/About";
import Service from "../component/Home/Service";

import Advance from "../component/Home/Advance";
import Proccess from "../component/Home/Proccess";
import Team from "../component/Home/Team";
import Clients from "../component/Home/Clients";
import { lan } from "../lan";
import { motion } from "framer-motion";
import GoogleReviews from "../component/Home/GoogleReview";
import SuccesStories from "../component/Home/SuccesStories";
import MetaTags from "../component/MetaTags";
import Helmet from 'react-helmet';

class OurServicesPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      lan_list: "",
    };
  }

  componentDidMount() {
    let tempLan = [];
    if (typeof window !== "undefined") {
      tempLan = lan[localStorage.getItem("lan")];
    } else if (typeof window == "undefined") {
      tempLan = lan["en"];
    } else {
      tempLan = lan["en"];
    }
    this.setState({ lan_list: tempLan });
  }

  render() {
    const pageVariants = {
      initial: {
        opacity: 0,
      },
      in: {
        opacity: 1,
      },
      out: {
        opacity: 0,
      },
    };
    const { lan_list } = this.state;

    return (
      <>
        <main>
          <Navbar />
          <motion.div
            initial="initial"
            animate="in"
            exit="out"
            variants={pageVariants}
          >
            <Carousels banner={lan_list?.["banner"]} />
            <main id="main">
              <GoogleReviews />
              <Service val={lan_list} />
              <About val={lan_list} />
              <Advance val={lan_list} />
              <Team />
              <Proccess />
              <GoogleReviews />
              <SuccesStories />
              <Clients />
              <Footer />
            </main>
          </motion.div>
          <MetaTags
            title={"Our Services | Koderbox"}
            description={lan_list.info?.[2] || "Koderbox's full range of services: foreign language courses, coding classes, and custom software development."}
            path="/our-services/"
          />
        </main>
      </>
    );
  }
}

export default OurServicesPage;
